import { render, staticRenderFns } from "./FarmerSamples.vue?vue&type=template&id=50309d56&scoped=true"
import script from "./FarmerSamples.vue?vue&type=script&lang=js"
export * from "./FarmerSamples.vue?vue&type=script&lang=js"
import style0 from "./FarmerSamples.vue?vue&type=style&index=0&id=50309d56&prod&scoped=true&lang=css"
import style1 from "./FarmerSamples.vue?vue&type=style&index=1&id=50309d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50309d56",
  null
  
)

export default component.exports